import { useEffect } from 'react'

import { useMaestroSession } from '@maestro/commerce-blocks/providers/maestro-session/maestro-session.context'
import { theme } from '@maestro/local/theme'
import { useHash } from '@pearlconvert/ui/hooks/use-hash'

export function useRegisterModal() {
  const { session } = useMaestroSession()
  const { getHashParamValue, removeHashParam } = useHash()
  const registerModalKey = theme().registerPage.modalKey

  useEffect(() => {
    const hasRegisterHash = getHashParamValue(registerModalKey) !== undefined
    const isUserLoggedIn = !!session?.user?.id

    if (hasRegisterHash && isUserLoggedIn) {
      removeHashParam(registerModalKey)
    }
  }, [session?.user?.id, getHashParamValue, removeHashParam, registerModalKey])

  return { registerModalKey }
}
